module.exports = __webpack_public_path__ + "img/categories_less_radius.c5488d0c.svg";